<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Margie Woods, a Texas native, is an innovative author with stories as deep as the heart of this great state. The inspiration of the many novels she writes comes from a world within her mind’s eye, which is most definitely thought-provoking, stimulating, passionate, and gives a creative beauty and bloom to the unconventional. She is an artist who gives living color to fiction, non-fiction, lyrics, and poems.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?891bd7a6